// ------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by the @augloop/code-gen tool.
// Source: https://dev.azure.com/office/ISS/_git/augloop-server?path=%2Fmodules%2Fschemas%2Fsrc%2Fclientmetadata-schema.ts
// Changes to this file may cause incorrect behavior and will be lost upon regeneration.
// </auto-generated>
// ------------------------------------------------------------------------------
import { validateArray } from '@augloop/validator-common';
export class ServiceGroupsValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'ServiceGroups: Expected object, got undefined object for ServiceGroupsValidator' };
        }
        if ((obj.officeServiceGroup !== undefined) && (typeof obj.officeServiceGroup !== 'number')) {
            return { success: false, error: 'ServiceGroups: Optional field "officeServiceGroup" is wrong type' };
        }
        if ((obj.controllerServiceGroup !== undefined) && (typeof obj.controllerServiceGroup !== 'number')) {
            return { success: false, error: 'ServiceGroups: Optional field "controllerServiceGroup" is wrong type' };
        }
        return { success: true };
    }
}
export const serviceGroupsValidatorInstance = new ServiceGroupsValidator();
export class ClientMetadataValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'ClientMetadata: Expected object, got undefined object for ClientMetadataValidator' };
        }
        if ((obj.appName !== undefined) && (typeof obj.appName !== 'string')) {
            return { success: false, error: 'ClientMetadata: Optional field "appName" is wrong type' };
        }
        if ((obj.appPlatform !== undefined) && (typeof obj.appPlatform !== 'string')) {
            return { success: false, error: 'ClientMetadata: Optional field "appPlatform" is wrong type' };
        }
        if ((obj.runtimeVersion !== undefined) && (typeof obj.runtimeVersion !== 'string')) {
            return { success: false, error: 'ClientMetadata: Optional field "runtimeVersion" is wrong type' };
        }
        if ((obj.appVersion !== undefined) && (typeof obj.appVersion !== 'string')) {
            return { success: false, error: 'ClientMetadata: Optional field "appVersion" is wrong type' };
        }
        if ((obj.releaseAudienceGroup !== undefined) && (typeof obj.releaseAudienceGroup !== 'string')) {
            return { success: false, error: 'ClientMetadata: Optional field "releaseAudienceGroup" is wrong type' };
        }
        if ((obj.releaseChannel !== undefined) && (typeof obj.releaseChannel !== 'string')) {
            return { success: false, error: 'ClientMetadata: Optional field "releaseChannel" is wrong type' };
        }
        if ((obj.releaseFork !== undefined) && (typeof obj.releaseFork !== 'string')) {
            return { success: false, error: 'ClientMetadata: Optional field "releaseFork" is wrong type' };
        }
        if ((obj.sessionId !== undefined) && (typeof obj.sessionId !== 'string')) {
            return { success: false, error: 'ClientMetadata: Optional field "sessionId" is wrong type' };
        }
        if ((obj.flights !== undefined) && (typeof obj.flights !== 'string')) {
            return { success: false, error: 'ClientMetadata: Optional field "flights" is wrong type' };
        }
        if ((obj.uiLanguage !== undefined) && (typeof obj.uiLanguage !== 'string')) {
            return { success: false, error: 'ClientMetadata: Optional field "uiLanguage" is wrong type' };
        }
        if ((obj.privateMode !== undefined) && (typeof obj.privateMode !== 'boolean')) {
            return { success: false, error: 'ClientMetadata: Optional field "privateMode" is wrong type' };
        }
        if (obj.disabledServiceGroups !== undefined) {
            const result = validateArray(obj.disabledServiceGroups, 1, serviceGroupsValidatorInstance, '{ServiceGroups}');
            if (!result.success) {
                result.error = "ClientMetadata.disabledServiceGroups: " + result.error;
                return result;
            }
        }
        if ((obj.docSessionId !== undefined) && (typeof obj.docSessionId !== 'string')) {
            return { success: false, error: 'ClientMetadata: Optional field "docSessionId" is wrong type' };
        }
        if ((obj.os !== undefined) && (typeof obj.os !== 'string')) {
            return { success: false, error: 'ClientMetadata: Optional field "os" is wrong type' };
        }
        if ((obj.osVersion !== undefined) && (typeof obj.osVersion !== 'string')) {
            return { success: false, error: 'ClientMetadata: Optional field "osVersion" is wrong type' };
        }
        if ((obj.userAgent !== undefined) && (typeof obj.userAgent !== 'string')) {
            return { success: false, error: 'ClientMetadata: Optional field "userAgent" is wrong type' };
        }
        if ((obj.deviceId !== undefined) && (typeof obj.deviceId !== 'string')) {
            return { success: false, error: 'ClientMetadata: Optional field "deviceId" is wrong type' };
        }
        if ((obj.roamingServiceAppId !== undefined) && (typeof obj.roamingServiceAppId !== 'number')) {
            return { success: false, error: 'ClientMetadata: Optional field "roamingServiceAppId" is wrong type' };
        }
        if ((obj.releaseCustomAudience !== undefined) && (typeof obj.releaseCustomAudience !== 'string')) {
            return { success: false, error: 'ClientMetadata: Optional field "releaseCustomAudience" is wrong type' };
        }
        if ((obj.tenantGroup !== undefined) && (typeof obj.tenantGroup !== 'string')) {
            return { success: false, error: 'ClientMetadata: Optional field "tenantGroup" is wrong type' };
        }
        if ((obj.documentId !== undefined) && (typeof obj.documentId !== 'string')) {
            return { success: false, error: 'ClientMetadata: Optional field "documentId" is wrong type' };
        }
        if ((obj.userSystemTimezone !== undefined) && (typeof obj.userSystemTimezone !== 'string')) {
            return { success: false, error: 'ClientMetadata: Optional field "userSystemTimezone" is wrong type' };
        }
        if ((obj.isClientTelemetrySampled !== undefined) && (typeof obj.isClientTelemetrySampled !== 'boolean')) {
            return { success: false, error: 'ClientMetadata: Optional field "isClientTelemetrySampled" is wrong type' };
        }
        if ((obj.userIdHint !== undefined) && (typeof obj.userIdHint !== 'string')) {
            return { success: false, error: 'ClientMetadata: Optional field "userIdHint" is wrong type' };
        }
        return { success: true };
    }
}
export const clientMetadataValidatorInstance = new ClientMetadataValidator();
//# sourceMappingURL=clientmetadata-schema-validator.g.js.map